/**
 * Szerepkörök megjelenítése — egy helyen.
 *
 * Korábban ez a négy szín-térkép négy külön fájlban élt (Navbar, UserPanel,
 * AdminPanel, UserDetailModal), és egy új szerepkörnél mindegyiket meg kellett
 * volna találni. A backend párja: `backend/src/utils/roles.js`.
 */

// A sablon `.chip`-színei (2026-10-04): owner = kiemelő, admin = borostyán, tester = kék.
export const ROLE_BADGE = {
  owner:  'bg-brand-500/[0.12] text-brand-400 border-brand-500/30',
  admin:  'bg-warn/[0.08] text-warn border-warn/35',
  tester: 'bg-info/[0.08] text-info border-info/35',
  user:   'bg-transparent text-gray-400 border-line-strong',
};

export const roleBadgeClass = (role) => ROLE_BADGE[role] || ROLE_BADGE.user;

/**
 * Moderálhatja-e a közösségi route-könyvtárat (Library review). A backend párja:
 * `utils/roles.js` canModerateLibrary — a tester itt kap jogot, az Admin Panelbe
 * viszont továbbra sem jut be.
 */
export const canModerateLibrary = (role) => role === 'owner' || role === 'admin' || role === 'tester';

/**
 * Amit az owner ki tud osztani. Az `owner` szándékosan hiányzik: ownert csak
 * közvetlenül az adatbázisban lehet csinálni.
 */
export const ASSIGNABLE_ROLES = [
  { id: 'admin',  label: 'Admin',  hint: 'Full staff access' },
  { id: 'tester', label: 'Tester', hint: 'Lifetime license, no staff access' },
  { id: 'user',   label: 'User',   hint: 'Normal account' },
];
